import { render } from "./importContacts.component.vue?vue&type=template&id=2485df9e"
import script from "./importContacts.component.vue?vue&type=script&lang=js"
export * from "./importContacts.component.vue?vue&type=script&lang=js"

import "./importContacts.component.vue?vue&type=style&index=0&id=2485df9e&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__